import { Row, Col, Input, Button, Form, Grid } from 'antd'
import React, { useState } from 'react'
import { login } from '../../services/cmsservice'
import Card from '../Card'
import logo from '../../assets/images/logo.png'
import './LoginPage.css'
import styles from './index.module.scss'

const LoginPage = ({ onLogin }) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [loginAttempts, setLoginAttempts] = useState(0)
  const { useBreakpoint } = Grid
  const screens = useBreakpoint()

  const onFinish = () => {
    setLoading(true)

    login({
      username: username,
      password: password
    })
      .then((res) => {
        console.log(res)
        const { token, refreshToken, userInfo, permissions, tokenWeb } = res

        if (token) {
          setErrorMessage('')
          localStorage.setItem('access_token', token)
          localStorage.setItem('refresh_token', refreshToken)
          localStorage.setItem('user_name', userInfo.name)
          localStorage.setItem('user_phone', userInfo.phone)
          localStorage.setItem('user_email', userInfo.email)
          localStorage.setItem('user_role', userInfo.user_role)
          localStorage.setItem('department_id', userInfo.department_info.id)
          localStorage.setItem('permissions', JSON.stringify(permissions))
          localStorage.setItem('tokenWeb', tokenWeb)
          onLogin()

          setLoading(false)
        }
      })
      .catch((error) => {
        console.log(error)
        setLoginAttempts((prev) => prev + 1)
        // setErrorMessage('Tên người dùng hoặc mật khẩu không đúng.')
        setErrorMessage(error?.response?.data?.message || 'Tên người dùng hoặc mật khẩu không đúng.')
        setLoading(false)
        // openNotification('error', error?.response?.data?.message || 'Đã có lỗi xảy ra')
      })
  }

  return (
    <Row
      className={styles.wrapper + ' min-h-screen'}
      style={{ height: '100vh' }}
      justify={screens.lg ? 'start' : 'center'}
      align="middle"
    >
      <Col
        xs={24}
        md={screens.lg ? 12 : 24}
        className="flex items-center justify-center bg-light p-4"
        style={{ height: '100vh' }}
      >
        <div className="w-full" style={{ maxWidth: '400px' }}>
          <Card className="px-4 py-5">
            <div className="w-full flex justify-center">
              <img
                src={logo}
                alt="Logo"
                style={{ height: 35, width: 80, marginBottom: 16 }}
              />
            </div>
            <h2 className="text-center font-bold mb-4" style={{ fontSize: 24 }}>
              Đăng nhập
            </h2>
            <Form
              form={form}
              name="login"
              layout="vertical"
              onFinish={onFinish}
              style={{ marginTop: '20px' }}
            >
              <Form.Item
                label="Tên đăng nhập"
                name="username"
                rules={[
                  { required: true, message: 'Vui lòng nhập tên đăng nhập!' }
                ]}
              >
                <Input
                  placeholder="Nhập tên đăng nhập"
                  onChange={(e) => setUsername(e.target.value)}
                  style={{ height: 40 }}
                />
              </Form.Item>

              <Form.Item
                label="Mật khẩu"
                name="password"
                rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}
              >
                <Input.Password
                  placeholder="Nhập mật khẩu"
                  onChange={(e) => setPassword(e.target.value)}
                  style={{ height: 40 }}
                />
              </Form.Item>

              {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}

              <Form.Item>
                <Button
                  htmlType="submit"
                  className="w-full"
                  type="primary"
                  style={{ height: 40, fontSize: 14 }}
                  loading={loading}
                >
                  Đăng nhập
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </div>
      </Col>

      {screens.lg && (
        <Col
          lg={12}
          className="flex items-center justify-center bg-transparent text-white p-4"
          style={{ height: '100vh' }}
        />
      )}
    </Row>
  )
}

export default LoginPage
